export default "__VITE_ASSET__2CpT3C0g__"